export default {
  metadata: {
    version: '1.0.0',
    id: 'stepper-vertical-step-item-1.0.0',
    name: 'JDSVerticalStepItem'
  },
  hierarchy: {
    'stepper-outer-container': [
      {
        'step-dot-container': ['jds_stepper_dot', 'label-jds-text']
      },
      {
        'step-indicator-container': [
          'end-jds_divider',
          {
            'content-container': [
              {
                'content-child-container': ['content-slot']
              }
            ]
          }
        ]
      }
    ]
  },
  base: {
    'stepper-outer-container': {
      'flex-direction': '{v_0}',
      'justify-content': '{v_1}',
      'align-items': '{v_2}',
      gap: '{v_3}',
      size: '{v_4}'
    },
    'end-container': {
      hidden: false,
      flex: 1,
      opacity: '{v_5}'
    },
    'content-child-container': {
      'flex-direction': '{v_6}',
      'justify-content': '{v_7}',
      'align-items': '{v_8}',
      hidden: false
    },
    'end-jds_divider': {
      pad: 'none',
      withLabel: false,
      orientation: 'vertical'
    },
    'step-indicator-container': {
      height: '{v_9}',
      'flex-direction': '{v_10}',
      'justify-content': '{v_11}',
      'align-items': '{v_12}',
      'padding-left': 15,
      'min-height': '{v_13}'
    },
    'step-dot-container': {
      'flex-direction': '{v_15}',
      'justify-content': '{v_16}',
      'align-items': '{v_17}',
      gap: '{v_18}'
    },
    'content-container': {
      'padding-top': '{v_19}',
      'padding-left': 31,
      'padding-bottom': '{v_20}',
      'enter-animation-name': 'slideVerticallyDown',
      'exit-animation-name': 'slideVerticallyUp',
      'enter-animation-curve': 'entrance_ease',
      'exit-animation-curve': 'exit_ease',
      'enter-animation-duration': 500,
      'exit-animation-duration': 500,
      hidden: true,
      overflow: 'hidden',
      transition: {
        property: ['max-height', 'padding-top', 'padding-bottom'],
        duration: '{medium}',
        'timing-function': '{easeExit}'
      }
    },
    'label-jds-text': {
      'font-family': '{text_91}',
      color: '{text_20}',
      'font-size': '{text_90}',
      'line-height': '{text_92}',
      'letter-spacing': '{text_93}',
      'font-weight': '{text_94}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      language: 'en',
      'padding-top': 0
    }
  },
  variant: {
    _hideChild: {
      true: {
        'content-container': {
          hidden: false,
          'padding-top':
            '{verticalstepitem_variant__hideChild_true_content-container_padding-top}',
          'padding-bottom':
            '{verticalstepitem_variant__hideChild_true_content-container_padding-bottom}',
          transition: {
            'timing-function': '{easeEntrance}'
          }
        }
      }
    },
    state: {
      complete: {
        'end-jds_divider': {
          variant: 'stepper'
        }
      },
      disabled: {
        'stepper-outer-container': {
          disabled: true
        },
        jds_stepper_dot: {
          state: 'disabled'
        }
      }
    },
    direction: {
      start: {
        'end-jds_divider': {
          opacity: '{v_24}'
        }
      }
    }
  },
  api: {
    children: {
      'content-slot': {
        name: 'content',
        accepts: ['template'],
        max: 1
      }
    },
    config: {
      state: {
        type: 'JDSStepperDot.state',
        values: ['inactive', 'active', 'complete', 'disabled']
      },
      direction: {
        values: ['both', 'start', 'end']
      },
      _hideChild: {
        values: [true, false]
      }
    },
    data: {
      jds_stepper_dot: {
        index: {
          type: 'string',
          name: 'index'
        },
        icon: {
          type: 'icon',
          name: 'icon'
        },
        state: {
          type: 'JDSStepperDot.state',
          name: 'state'
        },
        itemsType: {
          type: 'JDSStepperDot.itemsType',
          name: 'itemsType'
        },
        activeState: {
          type: 'JDSStepperDot.activeState',
          name: 'activeState'
        }
      },
      'content-container': {
        'max-height': {
          name: '_contentHeight',
          type: 'size'
        }
      },
      'label-jds-text': {
        value: {
          name: 'label',
          type: 'string'
        }
      }
    },
    a11y: {
      'stepper-outer-container': {
        properties: {
          role: {
            value: 'listitem'
          },
          'aria-label': {
            name: 'ariaLabel',
            prop: 'label'
          },
          'aria-current': {
            name: 'ariaCurrent'
          }
        }
      }
    }
  }
};
